import { apiGet, apiPatch, apiPost } from './client';

export function getMyProfile() {
  return apiGet('/me/profile');
}

export function getMyWallet() {
  return apiGet('/me/wallet');
}

export function getMyTransactions({ transactionType, limit = 50, offset = 0 } = {}) {
  const params = new URLSearchParams();
  if (transactionType) params.set('transaction_type', transactionType);
  params.set('limit', String(limit));
  params.set('offset', String(offset));
  return apiGet(`/me/transactions?${params.toString()}`);
}

export function transferPoints(receiverUserId, amount, comment) {
  const idempotencyKey =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;

  return apiPost('/me/transfer', {
    receiver_user_id: Number(receiverUserId),
    amount: Number(amount),
    comment: comment || null
  }, {
    headers: {
      'Idempotency-Key': idempotencyKey
    }
  });
}

export function updateMyProfile(payload) {
  return apiPatch('/me/profile', payload);
}

export function getSkillSuggestions(query, limit = 20) {
  const params = new URLSearchParams();
  if (query) params.set('q', query);
  params.set('limit', String(limit));
  return apiGet(`/me/skills?${params.toString()}`);
}

export function createMyAvatarUploadUrl(file) {
  return apiPost('/me/avatar/upload-url', {
    filename: file.name,
    content_type: file.type || 'application/octet-stream',
    content_length: file.size,
  });
}

export async function uploadAvatarFile(uploadIntent, file) {
  const response = await fetch(uploadIntent.upload_url, {
    method: uploadIntent.method || 'PUT',
    headers: {
      'Content-Type': file.type || 'application/octet-stream',
    },
    body: file,
  });
  if (!response.ok) {
    throw new Error(`Ошибка загрузки файла: ${response.status}`);
  }
}

export function commitMyAvatar(mediaUrl) {
  return apiPost('/me/avatar/commit', { media_url: mediaUrl });
}

export function createMyProfileShareLink() {
  return apiPost('/me/share-link', {});
}

export function getSharedProfile(token) {
  return apiGet(`/profiles/share/${encodeURIComponent(token)}`, { auth: false });
}
